const internationalConverter = (text) => {
	const js = {
		"!!": "¡",
		"??": "¿",
		"a'": "á",
		"a`": "à",
		"a^": "â",
		"a~": "ã",
		"c'": "ç",
		"e'": "é",
		"e`": "è",
		"e^": "ê",
		"i'": "í",
		"i`": "ì",
		"o'": "ó",
		"o`": "ò",
		"o^": "ô",
		"o~": "õ",
		"u'": "ú",
		"u`": "ù",
		"u<": "ü",
		"n~": "ñ"
	};
	return Object.keys(js)
		.filter((k) => text.includes(k))
		.reduce((new_text, current_key) => {
			return new_text.replaceAll(current_key, js[current_key]);
		}, text);
};

export default internationalConverter;
